import { render } from "./pobierzLink.vue?vue&type=template&id=7b5e016d&scoped=true"
import script from "./pobierzLink.vue?vue&type=script&lang=js"
export * from "./pobierzLink.vue?vue&type=script&lang=js"

import "./pobierzLink.vue?vue&type=style&index=0&id=7b5e016d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b5e016d"]])

export default __exports__